import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import './css/style.css';

export default class HelpWidget extends React.Component {
    constructor(props) {
        super(props);

        var stringhe = props.text.split('##');

        this.state = {
            open: false,
            testi: stringhe,
        };
    }

    render() {

        return(
            <section className='help-widget' onClick={() => this.setState({ open: !this.state.open })}>
                <h3>{this.props.titolo}</h3>
                { this.state.open && (
                    <>
                        <p>
                        { this.state.testi.map((t) => {
                            
                            if (isNaN(t)) {
                                return(
                                    <span>{ReactHtmlParser(t)}</span>
                                );
                            } else {
                                return(
                                    <span>{this.props.immagini[parseInt(t)]}</span>
                                );
                            }
                        })}
                        </p>
                    </>
                )}
                <div style={{ width: '100%', height: 1, backgroundColor: 'lightgrey' }} />
            </section>
        );
    }
}